/**
 * O aviso de nova versao — `PWA §5.2`, PWA-011 e PWA-012.
 *
 * Tres requisitos, e o codigo de cada um:
 *
 * | Requisito | Como aparece aqui |
 * | --------- | ----------------- |
 * | PWA-011 — suprimido em fluxo critico | o estado vem de `usePwa().atualizacao`; em `PENDENTE`, este componente **nao renderiza nada** |
 * | PWA-012 — se ignorado, nao vira modal | e um `<aside role="status">`, nao um `<dialog>`; nao ha overlay, nao ha foco preso, nao ha bloqueio |
 * | PWA-010 — `skipWaiting` so por toque | o botao chama `aplicarAtualizacao()`, que e quem manda a mensagem ao service worker |
 *
 * O botao "Agora nao" existe e tem o **mesmo peso visual de um botao de verdade** (§40,
 * anti-dark-pattern): recusa escondida, cinza-sobre-cinza ou como link minusculo e exatamente o
 * padrao que o briefing proibe.
 */

import { Button } from '@farmacia/ui';
import { useState, type ReactNode } from 'react';

import { texto } from '../../conteudo/index.js';
import { usePwa } from '../../pwa/contexto.jsx';

export function AvisoDeAtualizacao(): ReactNode {
  const { atualizacao, aplicarAtualizacao } = usePwa();
  const [adiado, setAdiado] = useState(false);

  // `PENDENTE` (fluxo critico) e `OCIOSO` nao renderizam. `APLICANDO` tambem nao: a pagina esta
  // prestes a recarregar, e um aviso piscando antes do reload e ruido.
  if (atualizacao.tipo !== 'DISPONIVEL' || adiado) return null;

  return (
    <aside className="aviso-atualizacao" role="status" aria-label={texto('atualizacao.titulo')}>
      <p className="aviso-atualizacao__texto">{texto('atualizacao.titulo')}</p>
      <div className="aviso-atualizacao__acoes">
        <Button variant="primary" size="sm" onClick={aplicarAtualizacao}>
          {texto('atualizacao.acao')}
        </Button>
        <Button variant="secondary" size="sm" onClick={() => { setAdiado(true); }}>
          {texto('atualizacao.adiar')}
        </Button>
      </div>
    </aside>
  );
}
